<template>
  <div style="margin: 0 auto">
    <b-row>
      <b-col cols="12">
        <h2 id="navigation-title">Plugins</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-row>
          <b-col cols="12" class="text-right">
            <b-button class="ozg-button" @click="openCrud"
              >Daten hinzufügen</b-button
            >
          </b-col>
          <b-col cols="12">
            <b-table
              :fields="fields"
              :items="items"
              :class="'collectionTable' + currentTableKey"
            >
              <template v-slot:cell(icon)="{ item }">
                <b-icon :icon="item.icon"></b-icon>
              </template>
              <template v-slot:cell(defaults)="{ item }">
                <b-button
                  @click="showDefaults(item)"
                  class="ozg-button small simple"
                >
                  <small><b-icon-input-cursor></b-icon-input-cursor></small>
                </b-button>
              </template>

              <template v-slot:cell(settings)="{ item }">
                <b-button
                  @click="showSettings(item)"
                  class="ozg-button small simple"
                >
                  <small><b-icon-gear></b-icon-gear></small>
                </b-button>
              </template>
              <template v-slot:cell(actions)="{ item }">
                <div style="width: 65px">
                  <b-icon-pen
                    style="margin-right: 10px; cursor: pointer"
                    font-scale="1"
                    v-b-tooltip.hover
                    title=" bearbeiten"
                    @click="editCollectionItem(item)"
                  ></b-icon-pen>

                  <b-icon-files
                    font-scale="1"
                    v-b-tooltip.hover
                    style="margin-right: 10px; cursor: pointer"
                    title=" kopieren"
                    @click="copyCollectionItem(item)"
                  >
                  </b-icon-files>
                  <b-icon-trash
                    font-scale="1"
                    v-b-tooltip.hover
                    style="cursor: pointer"
                    title=" löschen"
                    @click="deleteCollectionItem(item)"
                  >
                  </b-icon-trash>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import config from "@/config/config.js";
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      fields: [
        {
          key: "pluginId",
          label: "#",
          sortable: false,
        },
        {
          key: "icon",
          label: "icon",
          sortable: false,
        },
        {
          key: "title",
          label: "Plugin-Name",
          sortable: false,
        },
        {
          key: "pluginKey",
          label: "Identifier",
          sortable: false,
        },

        {
          key: "isEditable",
          label: "Kann editiert werden?",
          sortable: false,
        },

        {
          key: "hasSettings",
          label: "Kann eingestellt werden?",
          sortable: false,
        },

        {
          key: "hasWidget",
          label: "Widget verfügbar",
          sortable: false,
        },
        {
          key: "defaults",
          label: "Standwerte",
          sortable: false,
        },
        {
          key: "settings",
          label: "Einstellungen",
          sortable: false,
        },
        {
          key: "created_at",
          label: "Erstellt",
          sortable: false,
        },
        {
          key: "updated_at",
          label: "Bearbeitet",
          sortable: false,
        },

        {
          key: "actions",
          label: "Aktionen",
          sortable: false,
        },
      ],
      editFields: [
        {
          key: "title",
          title: "Plugin-Name",
          type: "text",
        },
        {
          key: "pluginKey",
          title: "Identifier",
          type: "text",
        },
        {
          key: "pluginGroupId",
          title: "Plugin-Gruppe",
          type: "foreign",
          foreignController: "PluginGroup",
          foreignValue: "pluginGroupId",
          foreignText: "title",
        },
        {
          key: "pluginTypeId",
          title: "Plugin-Type",
          type: "foreign",
          foreignController: "PluginType",
          foreignValue: "pluginTypeId",
          foreignText: "title",
        },

        {
          key: "dataObjectId",
          title: "Daten-Objekt",
          type: "foreign",
          foreignController: "DataObject",
          foreignValue: "dataObjectId",
          foreignText: "title",
        },
        {
          key: "icon",
          title: "Icon",
          type: "text",
        },

        {
          key: "isEditable",
          title: "Kann editiert werden?",
          type: "switch",
        },

        {
          key: "hasSettings",
          title: "Kann eingestellt werden?",
          type: "switch",
        },

        {
          key: "hasWidget",
          title: "Hat Widgets?",
          type: "switch",
        },

        {
          key: "description",
          title: "Beschreibung",
          type: "text",
        },
      ],
      items: [],
      currentTableKey: 1,
    };
  },

  mounted() {
    this.currentTableKey = moment().format("X");

    this.initializePlugins();
  },

  methods: {
    initializePlugins() {
      axios.get(config.API_URL + "/api/plugin").then((response) => {
        this.items = response.data;
        $(document).ready(function () {
          $(".collectionTable" + this.currentTableKey).DataTable({
            language: {
              url: "//cdn.datatables.net/plug-ins/2.0.8/i18n/de-DE.json",
            },
          });
        });
      });
    },

    openCrud() {
      let self = this;
      this.$root.$children[0].showBaseModal = true;

      this.$root.$children[0].baseDialogComponentName = "DynamicCrudDialog";
      this.$root.$children[0].baseDialogData = {};
      this.$root.$children[0].baseDialogData.item = {};
      this.$root.$children[0].baseDialogData.fields = this.editFields;

      this.$root.$children[0].baseDialogData.saveFunction = function () {
        self.saveData(self.$root.$children[0].baseDialogData.item);
      };
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    editCollectionItem(item) {
      let self = this;
      this.$root.$children[0].showBaseModal = true;

      this.$root.$children[0].baseDialogComponentName = "DynamicCrudDialog";
      this.$root.$children[0].baseDialogData = {};

      this.$root.$children[0].baseDialogData.item = item;

      this.$root.$children[0].baseDialogData.fields = this.editFields;

      this.$root.$children[0].baseDialogData.saveFunction = function () {
        self.saveData(self.$root.$children[0].baseDialogData.item);
      };
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    deleteCollectionItem(item) {
      var deleteItem = confirm("Wirklich löschen?");

      if (deleteItem) {
        axios
          .delete(config.API_URL + "/api/plugin/" + item.pluginId)
          .then((response) => {
            this.$root.$children[0].showBaseModal = false;
            this.initializePlugins();
          });
      }
    },

    showDefaults(item) {
      let self = this;
      this.$root.$children[0].showBaseModal = true;

      this.$root.$children[0].baseDialogComponentName = "JSONEditorDialog";
      this.$root.$children[0].baseDialogData = {};
      this.$root.$children[0].baseDialogData.json = JSON.parse(item.defaults);
      this.$root.$children[0].baseDialogData.saveFunction = function () {
        self.saveDefaults(item, self.$root.$children[0].baseDialogData.json);
      };
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    showSettings(item) {
      let self = this;
      this.$root.$children[0].showBaseModal = true;

      this.$root.$children[0].baseDialogComponentName = "JSONEditorDialog";
      this.$root.$children[0].baseDialogData = {};
      this.$root.$children[0].baseDialogData.json = JSON.parse(item.settings);
      this.$root.$children[0].baseDialogData.saveFunction = function () {
        self.saveSettings(item, self.$root.$children[0].baseDialogData.json);
      };
      this.$root.$children[0].baseDialogData.Key = moment().format("X");
    },

    saveDefaults(item, definition) {
      item.defaults = JSON.stringify(definition);

      axios
        .put(config.API_URL + "/api/plugin/" + item.pluginId, item)
        .then((response) => {
          this.$root.$children[0].showBaseModal = false;
        });
    },

    saveSettings(item, definition) {
      item.settings = JSON.stringify(definition);

      axios
        .put(config.API_URL + "/api/plugin/" + item.pluginId, item)
        .then((response) => {
          this.$root.$children[0].showBaseModal = false;
        });
    },

    saveData(item) {
      let self = this;

      if (
        item.pluginId != null &&
        item.pluginId != undefined &&
        item.pluginId != -1
      ) {
        axios
          .put(config.API_URL + "/api/plugin/" + item.pluginId, item)
          .then((response) => {
            this.$root.$children[0].showBaseModal = false;
            this.initializePlugins();
          });
      } else {
        axios.post(config.API_URL + "/api/plugin/", item).then((response) => {
          this.$root.$children[0].showBaseModal = false;
          this.initializePlugins();
        });
      }
    },
  },
};
</script>